module.exports = __webpack_public_path__ + "media/centro-hd.078a4695.mp4";